import {
  BodyText,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  LargeText,
  SmallText
} from '@epilot/base-elements'
import { ReactNode } from 'react'

export enum TEXT_TYPE {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  LARGE = 'LARGE',
  BODY = 'BODY',
  SMALL = 'SMALL'
}

interface Props {
  children: ReactNode
  type: TEXT_TYPE
}

const Text = ({ type, children, ...restProps }: Props) => {
  switch (type) {
    case TEXT_TYPE.H1:
      return <H1 {...restProps}>{children}</H1>

    case TEXT_TYPE.H2:
      return <H2 {...restProps}>{children}</H2>

    case TEXT_TYPE.H3:
      return <H3 {...restProps}>{children}</H3>

    case TEXT_TYPE.H4:
      return <H4 {...restProps}>{children}</H4>

    case TEXT_TYPE.H5:
      return <H5 {...restProps}>{children}</H5>

    case TEXT_TYPE.H6:
      return <H6 {...restProps}>{children}</H6>

    case TEXT_TYPE.LARGE:
      return <LargeText {...restProps}>{children}</LargeText>

    case TEXT_TYPE.BODY:
      return <BodyText {...restProps}>{children}</BodyText>

    case TEXT_TYPE.SMALL:
      return <SmallText {...restProps}>{children}</SmallText>

    default:
      return null
  }
}

export default Text
